import React, { useState } from 'react';
import './UserForm.scss';

export default function UserForm({ user: initialUser = {}, customers = [], onSave, onCancel, onDelete }) {
  const [user, setUser] = useState({
    email: initialUser.email || '',
    firstName: initialUser.firstName || '',
    lastName: initialUser.lastName || '',
    id: initialUser.id || '',
    msId: initialUser.msId || '',
    enabled: initialUser.enabled ?? true,
    customerIds: Array.isArray(initialUser.customerIds) ? initialUser.customerIds : [],
    isAdmin: initialUser.isAdmin || false,
    isDeveloper: initialUser.isDeveloper || false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ensure customerIds is always an array with the selected customer
    const customerId = user.customerIds && user.customerIds.length > 0
      ? user.customerIds[0]
      : (user.customerId || (customers[0]?.id || ''));
    const customerIds = [customerId].filter(Boolean);
    const userToSave = { ...user, customerIds };
    delete userToSave.customerId;
    console.log('Submitting user:', userToSave);
    onSave(userToSave);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    if (onDelete) {
      onDelete(user);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 600 }} className="user-form">
      <h3>{user.id ? 'Edit User' : 'Add User'}</h3>
      {customers.length > 1 ? (
        <div className="field-group">
          <label>Client<br />
            <select
              value={user.customerId}
              onChange={e => setUser(u => ({ ...u, customerId: e.target.value }))}
              required
            >
              {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
        </div>
      ) : (
        <input type="hidden" value={user.customerId} />
      )}
      <div className="field-group">
        <label className="field-label">Email<br />
          <input
            type="email"
            className="admin-input"
            value={user.email}
            onChange={e => setUser(u => ({ ...u, email: e.target.value }))}
            required
          />
        </label>

        <label className="field-label">First Name<br />
          <input
            className="admin-input"
            value={user.firstName}
            onChange={e => setUser(u => ({ ...u, firstName: e.target.value }))}
          />
        </label>

        <label className="field-label">Last Name<br />
          <input
            className="admin-input"
            value={user.lastName}
            onChange={e => setUser(u => ({ ...u, lastName: e.target.value }))}
          />
        </label>

        <label className="field-label">User ID
        </label>
        <span >{user.id || ''}</span>

        <label className="field-label">MS ID
        </label>
        <span >{user.msId || ''}</span>
        <div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input
              type="checkbox"
              checked={user.enabled}
              onChange={e => setUser(u => ({ ...u, enabled: e.target.checked }))}
            />
            Enabled
          </label>
        </div>


        <div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input
              type="checkbox"
              checked={user.isAdmin}
              onChange={e => setUser(u => ({ ...u, isAdmin: e.target.checked }))}
            />
            Is Admin
          </label>
        </div>

        <div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input
              type="checkbox"
              checked={user.isDeveloper}
              onChange={e => setUser(u => ({ ...u, isDeveloper: e.target.checked }))}
            />
            Is Developer
          </label>
        </div>
      </div>
      <div style={{ marginTop: 12 }}>
        <button type="submit" className="button-primary">Save</button>
        <button type="button" onClick={handleCancel} style={{ marginLeft: 8 }} className="button-default">Cancel</button>
        <button type="button" onClick={handleDelete} style={{ marginLeft: 8 }} className="button-danger">Delete</button>
      </div>
    </form>
  );
}
